import React, { useState } from 'react';
import { SidebarMenuOptionItem } from './SidebarMenuOptionItem';
import { useLocation, useNavigate } from 'react-router-dom';

const normalizePath = (value = '/') => {
    const normalized = `/${String(value || '').replace(/^\/+|\/+$/g, '')}`;
    return normalized === '/' ? '/' : normalized;
};

const isPathActive = (basePath, currentPathname) => {
    const base = normalizePath(basePath);
    const current = normalizePath(currentPathname);

    if (!base || base === '/'){ 
        return current === '/';
    }

    return current === base || current.startsWith(`${base}/`);
};

export const SidebarMenuOption = ({title, icon, options, link}) => {

    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location?.pathname || '/';

    const handleNavigate = () => {
        navigate(link);
    };

    const hasChildren = Array.isArray(options) && options.length > 0;
    const isCurrentPathActive = Boolean(link) && isPathActive(link, pathname);
    const hasActiveChild = hasChildren && options.some((option) => isPathActive(option?.link, pathname));

    const [isOpen, setIsOpen] = useState(() => hasActiveChild);
    const [submenuMaxHeight, setSubmenuMaxHeight] = useState(0);
    const submenuRef = React.useRef(null);

    React.useEffect(() => {
        if (hasActiveChild) {
            setIsOpen(true);
        }
    }, [hasActiveChild]);

    React.useEffect(() => {
        if (!hasChildren) {
            setSubmenuMaxHeight(0);
            return;
        }

        const nextHeight = submenuRef.current?.scrollHeight || 0;
        setSubmenuMaxHeight(nextHeight);
    }, [hasChildren, options, isOpen]);

    const toggleMenu = () => {
        if (!hasChildren) {
            if (link) {
                handleNavigate();
            }
            return;
        }

        setIsOpen(!isOpen);
    }

    return(
        <li className={`nxl-item nxl-hasmenu ${(isOpen || hasActiveChild) ? 'nxl-trigger' : ''} ${(isCurrentPathActive || hasActiveChild) ? 'active' : ''}`}>
            <button
                type="button"
                className="nxl-link border-0 text-start sidebar-menu-link-btn"
                onClick={link ? handleNavigate : toggleMenu}
                style={{cursor:'pointer'}}
                aria-expanded={hasChildren ? isOpen : undefined}
            >
                <span className="nxl-micon"><i className={icon}></i></span>
                <span className="nxl-mtext">{title}</span>
                <span className="nxl-arrow"><i className="feather-chevron-right"></i></span>
            </button>
            <ul
                ref={submenuRef}
                className={`nxl-submenu sidebar-submenu ${isOpen ? 'is-open' : ''}`}
                style={{ maxHeight: isOpen ? `${submenuMaxHeight}px` : '0px' }}
            >
                {(options || []).map((option) => (<SidebarMenuOptionItem key={option.link} option={option} />))}
            </ul>
        </li>
    );
};
